/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Huu Khang Nguyen
 * Created: 01/02/22
 */

import { Flex } from '@chakra-ui/react';
import { SimpleAlert } from '@/components/SimpleAlert/SimpleAlert';
import React from 'react';

interface FormNotLoadedAlertProps {
    actionName?: string;
    formTitle?: string;
}

export const FormNotLoadedAlert = ({ actionName, formTitle }: FormNotLoadedAlertProps) => (
    <Flex justifyContent="center" mt={6}>
        <SimpleAlert variant="top-accent" title="Error">
            <>
                Could not load submitted {formTitle}
                {''}
                {actionName && ` to ${actionName}`}.
                <br />
                Refresh the page to try again, or return to Dashboard.
            </>
        </SimpleAlert>
    </Flex>
);
